/* ============================================
   Mers — canlı (predictive) arama.
   Bir arama input'una [data-predictive-search] koy → yazdıkça altında
   ürün önizleme penceresi açılır (Shopify /search/suggest.json).
   ============================================ */
(function () {
  'use strict';

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }
  function esc(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments, c = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(c, a); }, ms);
    };
  }

  function init(input) {
    var form = input.closest('form');
    if (!form) return;
    form.classList.add('psearch-host');
    form.setAttribute('autocomplete', 'off');

    var panel = document.createElement('div');
    panel.className = 'psearch';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    form.appendChild(panel);

    var ctrl = null;
    function close() { panel.hidden = true; panel.innerHTML = ''; }
    function open() { panel.hidden = false; }

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      panel.innerHTML = '<div class="psearch__msg">Aranıyor…</div>';
      open();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      fetch(url, { signal: ctrl.signal })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var products = (((d.resources || {}).results || {}).products) || [];
          render(q, products);
        })
        .catch(function (e) { if (e.name !== 'AbortError') close(); });
    }, 180);

    function render(q, products) {
      if (!products.length) {
        panel.innerHTML = '<div class="psearch__msg">“' + esc(q) + '” için ürün bulunamadı</div>';
        open();
        return;
      }
      var items = products.map(function (p) {
        var img = p.image ? ' style="background-image:url(' + p.image + ')"' : '';
        var price = money(p.price);
        var sold = p.available === false ? '<span class="psearch__soldout">Tükendi</span>' : '';
        return '<a class="psearch__item" href="' + p.url + '" role="option">' +
          '<span class="psearch__img"' + img + '></span>' +
          '<span class="psearch__info">' +
          '<span class="psearch__title">' + esc(p.title) + '</span>' +
          '<span class="psearch__metarow">' +
          (price ? '<span class="psearch__price">' + price + '</span>' : '') + sold +
          '</span></span></a>';
      }).join('');
      panel.innerHTML =
        '<div class="psearch__list">' + items + '</div>' +
        '<a class="psearch__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Tüm sonuçları gör →</a>';
      open();
    }

    input.addEventListener('input', run);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && panel.innerHTML) open();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  }

  document.querySelectorAll('[data-predictive-search]').forEach(init);
})();
